import script from "./PortfolioComponentMobile.vue?vue&type=script&setup=true&lang=js"
export * from "./PortfolioComponentMobile.vue?vue&type=script&setup=true&lang=js"

import "./PortfolioComponentMobile.vue?vue&type=style&index=0&id=0af31342&scoped=true&lang=css"

import exportComponent from "/opt/builds/JFRxnycJ/0/firma/firmenwebseite/website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0af31342"]])

export default __exports__